import {
  isOnline as isOnlineAtom,
} from '../index';

globalThis.addEventListener('online', () => isOnlineAtom.set(true));
globalThis.addEventListener('offline', () => isOnlineAtom.set(false));
